import React from 'react';
import Button from 'components/Button';
import {
  isSubFeatureDisabled,
  useEditorState,
} from '../context/VideoEditorStateContext';
import { useTemplateState } from '../context/VideoTemplateStateContext';
import { useCaptionsChildViewContext } from './CaptionsChildViewContext';

export type CaptionsChildViewEditCaptionStyleButtonProps = {
  label?: React.ReactNode;
};

const CaptionsChildViewEditCaptionStyleButton: React.FC<CaptionsChildViewEditCaptionStyleButtonProps> = ({
  label = 'edit caption style',
}) => {
  const { onEditCaptionsStyle } = useCaptionsChildViewContext();
  const { transcription } = useTemplateState();
  const { features } = useEditorState();
  const styleLocked = isSubFeatureDisabled(features, ['captions', 'style']);

  return (
    <Button
      fluid
      theme="submit"
      disabled={!transcription?.transcribe || styleLocked}
      onClick={onEditCaptionsStyle}
    >
      {label}
    </Button>
  );
};

export default CaptionsChildViewEditCaptionStyleButton;
